import { cn, Skeleton } from '@clarix/ui';

interface FormSkeletonProps {
  /** Number of label + field rows to render. */
  rows?: number;
  className?: string;
}

/**
 * Loading placeholder for settings-style forms (label + control rows).
 * Replaces the spinner so the page keeps its shape while data loads.
 */
export function FormSkeleton({ rows = 6, className }: FormSkeletonProps) {
  return (
    <div className={cn('space-y-5', className)} aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="space-y-2">
          <Skeleton className="h-3.5 w-32" />
          <Skeleton className="h-9 w-full rounded-md" />
        </div>
      ))}
    </div>
  );
}
